import { z } from "zod";

export const CustomPopupRecordSchema = z.object({
  text: z.string(),
  price: z.string(),
});

export const CustomPopupDataSchema = z.object({
  sections: z.record(z.string(), CustomPopupRecordSchema),
  rows: z.record(z.string(), CustomPopupRecordSchema),
  seats: z.record(z.string(), CustomPopupRecordSchema),
});

export const CustomPopupSchema = z.object({
  enabled: z.boolean(),
  data: CustomPopupDataSchema,
});

export const CustomPopupUiSchema = {
  text: '',
  price: ''
};

